@if (breadcrumbs?.length) {
<div>
    <div class="flex flex-middle no-wrap">
        @for (crumb of getAllCrumbs('Home'); track crumb;) {
        <!-- IMPORTANT: we need nested span cause optHref creats a node and that causes problems for angular repeater -->
        <span>
            <href class="c1"
                  [ngClass]="$last && isSelfLocation(crumb) ? 'col-1' : 'col-12'"
                  [link]="crumb.url">{{crumb.label}}</href>
        </span>
        <!--
        NOTE:
        size here in ems is to keep chevron scale propertionaly to the label
        this requires both span and i having the same typography class
        -->
        @if (!$last) {
        <i style="font-size: 12px;"
           [ngClass]="$index === getAllCrumbs('Home').length - 2 ? 'col-1' : 'col-12'"
           class="icon-chevron-right inline-flex"></i>
        }
        }
    </div>
</div>
}